"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var _a, _b, _c, _d;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tooltip = void 0;
var react_1 = __importStar(require("react"));
var colors_1 = require("../../../constants/colors");
var tooltip_1 = require("../../../constants/molecules/tooltip");
var TOOLTIP_COLORS = {
    TEXT_PRIMARY: colors_1.COLORS.TEXT_PRIMARY,
    SECONDARY: colors_1.COLORS.ZAMP_SECONDARY,
};
var TOOLTIP_BODY_COLOR_CLASSNAME_MAP = (_a = {},
    _a[TOOLTIP_COLORS.TEXT_PRIMARY] = 'tw-bg-TEXT_PRIMARY tw-text-white',
    _a[TOOLTIP_COLORS.SECONDARY] = 'tw-text-TEXT_SECONDARY tw-bg-ZAMP_SECONDARY',
    _a);
var CARET_COLOR_CLASSNAME_MAP = (_b = {},
    _b[TOOLTIP_COLORS.TEXT_PRIMARY] = (_c = {},
        _c[tooltip_1.TooltipPositions.RIGHT] = 'tw-border-r-TEXT_PRIMARY',
        _c[tooltip_1.TooltipPositions.RIGHT_TOP] = 'tw-border-r-TEXT_PRIMARY',
        _c[tooltip_1.TooltipPositions.LEFT] = 'tw-border-l-TEXT_PRIMARY',
        _c[tooltip_1.TooltipPositions.LEFT_TOP] = 'tw-border-l-TEXT_PRIMARY',
        _c[tooltip_1.TooltipPositions.BOTTOM] = 'tw-border-b-TEXT_PRIMARY',
        _c[tooltip_1.TooltipPositions.TOP] = 'tw-border-t-TEXT_PRIMARY',
        _c[tooltip_1.TooltipPositions.BOTTOM_RIGHT] = 'tw-border-b-TEXT_PRIMARY',
        _c[tooltip_1.TooltipPositions.BOTTOM_LEFT] = 'tw-border-b-TEXT_PRIMARY',
        _c[tooltip_1.TooltipPositions.TOP_RIGHT] = 'tw-border-t-TEXT_PRIMARY',
        _c[tooltip_1.TooltipPositions.TOP_LEFT] = 'tw-border-t-TEXT_PRIMARY',
        _c),
    _b[TOOLTIP_COLORS.SECONDARY] = (_d = {},
        _d[tooltip_1.TooltipPositions.RIGHT] = 'tw-border-r-ZAMP_SECONDARY',
        _d[tooltip_1.TooltipPositions.RIGHT_TOP] = 'tw-border-r-ZAMP_SECONDARY',
        _d[tooltip_1.TooltipPositions.LEFT] = 'tw-border-l-ZAMP_SECONDARY',
        _d[tooltip_1.TooltipPositions.LEFT_TOP] = 'tw-border-l-ZAMP_SECONDARY',
        _d[tooltip_1.TooltipPositions.BOTTOM] = 'tw-border-b-ZAMP_SECONDARY',
        _d[tooltip_1.TooltipPositions.TOP] = 'tw-border-t-ZAMP_SECONDARY',
        _d[tooltip_1.TooltipPositions.BOTTOM_RIGHT] = 'tw-border-b-ZAMP_SECONDARY',
        _d[tooltip_1.TooltipPositions.BOTTOM_LEFT] = 'tw-border-b-ZAMP_SECONDARY',
        _d[tooltip_1.TooltipPositions.TOP_RIGHT] = 'tw-border-t-ZAMP_SECONDARY',
        _d[tooltip_1.TooltipPositions.TOP_LEFT] = 'tw-border-t-ZAMP_SECONDARY',
        _d),
    _b);
var Tooltip = function (_a) {
    var _b, _c;
    var _d;
    var _e = _a.position, position = _e === void 0 ? tooltip_1.TooltipPositions.BOTTOM : _e, _f = _a.wrapperClassName, wrapperClassName = _f === void 0 ? 'tw-absolute tw-ease-in-out tw-duration-300 tw-opacity-0 tw-pointer-events-none' : _f, _g = _a.tooltipBodyClassName, tooltipBodyClassName = _g === void 0 ? 'tw-normal-case tw-w-full tw-relative tw-rounded-2.5 tw-py-4 tw-px-6' : _g, _h = _a.caratOverrideClassName, caratOverrideClassName = _h === void 0 ? 'tw-absolute tw-border-8 tw-border-solid tw-border-transparent tw-w-0 tw-h-0 tw-z-10' : _h, _j = _a.tooltipBody, tooltipBody = _j === void 0 ? '' : _j, style = _a.style, children = _a.children, _k = _a.wrapperStyle, wrapperStyle = _k === void 0 ? '' : _k, _l = _a.tooltipBodystyle, tooltipBodystyle = _l === void 0 ? '' : _l, _m = _a.className, className = _m === void 0 ? '' : _m, _o = _a.disabled, disabled = _o === void 0 ? false : _o, _p = _a.caratClassName, caratClassName = _p === void 0 ? '' : _p, _q = _a.color, color = _q === void 0 ? colors_1.COLORS.ZAMP_SECONDARY : _q, id = _a.id;
    var ref = react_1.useRef(null);
    var parentRef = react_1.useRef(null);
    var _r = react_1.useState({}), tooltipPosition = _r[0], setTooltipPosition = _r[1];
    var caratPostionStyle = (_b = {},
        _b[tooltip_1.TooltipPositions.RIGHT] = 'tw-m-auto -tw-left-4 tw-top-[calc(50%-8px)]',
        _b[tooltip_1.TooltipPositions.LEFT] = 'tw-m-auto -tw-right-4 tw-top-[calc(50%-8px)] ',
        _b[tooltip_1.TooltipPositions.BOTTOM] = 'tw-m-auto -tw-top-4 tw-left-[calc(50%-8px)]',
        _b[tooltip_1.TooltipPositions.TOP] = 'tw-m-auto -tw-bottom-4 tw-left-[calc(50%-8px)]',
        _b[tooltip_1.TooltipPositions.RIGHT_TOP] = 'tw-top-2.5 -tw-left-4',
        _b[tooltip_1.TooltipPositions.LEFT_TOP] = '-tw-right-4 tw-top-2.5',
        _b[tooltip_1.TooltipPositions.BOTTOM_RIGHT] = '-tw-top-4 tw-right-2.5',
        _b[tooltip_1.TooltipPositions.BOTTOM_LEFT] = '-tw-top-4 tw-left-2.5',
        _b[tooltip_1.TooltipPositions.TOP_RIGHT] = '-tw-bottom-4 tw-right-2.5',
        _b[tooltip_1.TooltipPositions.TOP_LEFT] = '-tw-bottom-4 tw-left-2.5',
        _b);
    var wrapperPositionStyle = (_c = {},
        _c[tooltip_1.TooltipPositions.RIGHT] = " tw-ml-2.5 tw-z-[500] tw-left-full",
        _c[tooltip_1.TooltipPositions.RIGHT_TOP] = "tw-ml-2.5 tw-z-[500] -tw-top-2.5 tw-left-full",
        _c[tooltip_1.TooltipPositions.LEFT] = 'tw-mr-2 tw-z-[500] tw-right-full',
        _c[tooltip_1.TooltipPositions.LEFT_TOP] = '-tw-top-2.5 tw-mr-2 tw-z-[500] tw-right-full',
        _c[tooltip_1.TooltipPositions.TOP] = ' tw-mb-2.5 tw-z-[500] tw-bottom-full',
        _c[tooltip_1.TooltipPositions.BOTTOM] = 'tw-mt-2.5 tw-z-[500] tw-top-full',
        _c[tooltip_1.TooltipPositions.TOP_RIGHT] = '-tw-right-2.5 tw-mb-2.5 tw-z-[500] tw-bottom-full',
        _c[tooltip_1.TooltipPositions.TOP_LEFT] = '-tw-left-2.5 tw-mb-2.5 tw-z-[500] tw-bottom-full',
        _c[tooltip_1.TooltipPositions.BOTTOM_RIGHT] = '-tw-right-2.5 tw-mt-2.5 tw-z-[500] tw-top-full',
        _c[tooltip_1.TooltipPositions.BOTTOM_LEFT] = '-tw-left-2.5 tw-mt-2.5 tw-z-[500] tw-top-full',
        _c);
    var calculatePositionStyle = react_1.useCallback(function (position) {
        var _a, _b, _c, _d;
        var style = {};
        var height = (_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.clientHeight;
        var width = (_b = ref === null || ref === void 0 ? void 0 : ref.current) === null || _b === void 0 ? void 0 : _b.clientWidth;
        var parentHeight = (_c = parentRef.current) === null || _c === void 0 ? void 0 : _c.clientHeight;
        var parentWidth = (_d = parentRef.current) === null || _d === void 0 ? void 0 : _d.clientWidth;
        if ([tooltip_1.TooltipPositions.LEFT, tooltip_1.TooltipPositions.RIGHT].includes(position)) {
            if (height && parentHeight) {
                height = height / 2;
                height = height - parentHeight / 2;
                style = { top: -height + 'px' };
            }
        }
        else {
            if (width && height && parentWidth && parentHeight) {
                switch (position) {
                    case tooltip_1.TooltipPositions.BOTTOM:
                    case tooltip_1.TooltipPositions.TOP: {
                        width = width / 2;
                        width = width - parentWidth / 2 - 2;
                        return { left: -width + 'px' };
                    }
                    case tooltip_1.TooltipPositions.LEFT:
                    case tooltip_1.TooltipPositions.RIGHT: {
                        height = height / 2;
                        height = height - parentHeight / 2;
                        return { top: -height + 'px' };
                    }
                }
            }
        }
        return style;
    }, []);
    react_1.useEffect(function () {
        setTooltipPosition(calculatePositionStyle(position));
    }, [position, calculatePositionStyle]);
    return (react_1.default.createElement("div", { ref: parentRef, className: "tw-relative tw-group/tooltip tw-cursor-pointer " + className, "data-testid": "tooltip-wrapper-" + id },
        children,
        !!tooltipBody && (react_1.default.createElement("div", { ref: ref, className: wrapperClassName + " " + wrapperStyle + " " + wrapperPositionStyle[position] + " " + (!disabled && 'group-hover/tooltip:tw-opacity-100 group-hover/tooltip:tw-pointer-events-auto'), style: style ? style : __assign({}, tooltipPosition), "data-testid": "tooltip-" + id },
            react_1.default.createElement("div", { className: tooltipBodyClassName + " " + TOOLTIP_BODY_COLOR_CLASSNAME_MAP[color] + " " + tooltipBodystyle, "data-testid": "tooltip-body-wrapper-" + id },
                react_1.default.createElement("div", { className: caratOverrideClassName + " " + caratPostionStyle[position] + " " + ((_d = CARET_COLOR_CLASSNAME_MAP[color]) === null || _d === void 0 ? void 0 : _d[position]) + " " + caratClassName, "data-testid": "tooltip-carat-" + id }),
                react_1.default.createElement("div", { className: '', "data-testid": "tooltip-body-" + id }, tooltipBody))))));
};
exports.Tooltip = Tooltip;
